// extracted by mini-css-extract-plugin
export default {"reviews":"xy","yotpo":"yy","wrapper":"zy","review_list":"Ay","carousel":"By","swiper-slide":"Cy","review":"Ey","title":"Fy","verified":"Gy"};
    if(module.hot) {
      // 1715091678785
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  